// thunks/userGuideThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getUserGuide } from "../../../services/userGuideService";

export const getUserGuideThunk = createAsyncThunk(
  "userGuide/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUserGuide();
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);
